export default function SiteFooter({ status = 'Private, in-browser' }: { status?: string }) {
  return (
    <footer className="landing-footer" aria-label="FreeAppBuilder footer">
      <div className="footer-brand">
        <span className="footer-mark" aria-hidden="true">F</span>
        <div>
          <strong>Free<span>App</span>Builder</strong>
          <div className="footer-dots" aria-hidden="true"><i /><i /><i /><i /><i /></div>
        </div>
      </div>
      <div className="footer-status"><i aria-hidden="true" /><span>{status}</span></div>
      <div className="footer-copy">
        <span>Built by FreeAppBuilder</span>
        <span>© 2026 FreeAppBuilder. All rights reserved.</span>
      </div>
    </footer>
  );
}
